import { WecomMessageType } from "../..";
import EventBus from "../event-bus";

const receiveMessageHook = new EventBus<WecomMessageType>("receiveMessageHook");

export default receiveMessageHook;
